<template>
  <div class="clearfix">
    <!-- 单张图片 -->
    <template v-if="count === 1 && isUpload">
      <div class="uplaod_r">
        <a-upload list-type="picture-card" class="avatar-uploader" :show-upload-list="false"
          :before-upload="beforeUpload">
          <!-- {{ imageUrl }} -->
          <img v-if="imageUrl" :src="$url + imageUrl" alt="avatar" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <!-- <a-upload name="file" :beforeUpload="beforeUpload" :showUploadList="false">
          <a-button icon="upload">选择图片</a-button>
        </a-upload> -->
        <span class="uplaod_f" v-if="type != 'video'">{{ autoCropWidths }}*{{ autoCropHeights }}</span>
      </div>
    </template>
    <template v-else-if="count === 1 && !isUpload">
      <div class="uplaod_r">
        <!-- <a-upload
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :before-upload="beforeUpload"
          :action="uploadImgUrl"
          @change="handleChange"
        >
          <img v-if="imageUrl" :src="$url + imageUrl" alt="avatar" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload> -->
        <a-upload :before-upload="beforeUpload" list-type="picture-card" class="avatar-uploader"
          :show-upload-list="false" :customRequest="customRequest" :accept="type == 'video' ? '.mp4' : '.jpg,.png'">
          <video controls v-if="type == 'video' && imageUrl">
            <source :src="$url + imageUrl" type="video/mp4" />
          </video>
          <img v-else-if="imageUrl" :src="$url + imageUrl" alt="avatar" @error="
            (e) => {
              e.target.src = errorImage
            }
          " />

          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <!-- <a-upload name="file" :beforeUpload="beforeUpload" :showUploadList="false">
          <a-button icon="upload">选择图片</a-button>
        </a-upload> -->
        <span class="uplaod_f" v-if="type != 'video'">{{ autoCropWidths }}*{{ autoCropHeights }}</span>
      </div>
    </template>
    <!-- 多图 -->
    <template v-else>
      <div class="uplaod_r">
        <!-- <a-upload class="avatar-uploader" :show-upload-list="true" :file-list="fileList"
          :list-type="type == 'image' ? 'picture-card' : 'picture'" :action="uploadImgUrl" :before-upload="beforeUpload"
          :headers="headers" :customRequest="customRequest" @change="changeImg" :showUploadList="{
            showRemoveIcon: true,
            showPreviewIcon: true,
          }" multiple :disabled="flage">
          <div v-if="type == 'file' || type == 'video'">
            <a-button> <a-icon type="upload" /> 上传 </a-button>
          </div>
          <div v-if="!disabled && fileList.length < count">
            <span v-if="type == 'image'">
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </span>
          </div>
        </a-upload> -->
        <!-- <span class="uplaod_f" v-if="type != 'video'">{{ autoCropWidth }}*{{ autoCropHeight }}</span> -->
        <a-upload list-type="picture" :before-upload="beforeUpload" :headers="headers" :customRequest="customRequest"
          @change="changeImg" class="upload-list-inline" multiple @preview="handlePreview" :fileList="fileList">
          <a-button> <a-icon type="upload" /> 上传全景图 </a-button>
        </a-upload>
        <!-- <a-upload
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          list-type="picture"
          :default-file-list="fileLists"
          class="upload-list-inline"
        >
          <a-button> <a-icon type="upload" /> upload 11</a-button>
        </a-upload> -->
      </div>
    </template>
    <span v-if="value && type == 'file'">
      <br />
      <a :href="value" target="_blank">{{ value }}</a>
    </span>
    <a-modal :visible="previewVisible" title="查看" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" @error="
        (e) => {
          e.target.src = errorImage
        }
      " class="imageVis" />
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-form-model-item label="场景名称" prop="sceneName">
          <a-input v-model="form.sceneName" placeholder="请输入" :maxLength="50" />
        </a-form-model-item>
        <div class="bottom-control">
          <a-space>
            <a-button type="dashed" @click="previewVisible = false"> 取消 </a-button>
            <a-button type="primary" @click="submitForm"> 保存 </a-button>
          </a-space>
        </div>
      </a-form-model>
    </a-modal>
    <caijian ref="caijian" @ok="handleOk" :autoCropWidth="autoCropWidth" :autoCropHeight="autoCropHeight"
      :visible="visibleCai" :fileName="fileName"></caijian>
  </div>
</template>

<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import caijian from './caijian.vue'
import { uploadAvatar, ossSignature, ossSigkey } from '@/api/system/user'
// import UploadFileToOSS from '@/utils/upload-file-to-oss.js'
import axios from 'axios'
import COS from 'cos-js-sdk-v5'
import moment from 'moment'
import setting from '@/locales/lang/zh-CN/setting'
export default {
  name: 'ImageUpload',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    isUpload: {
      type: Boolean,
      default: true,
    },
    isSize: {
      type: Boolean,
      default: false,
    },
    flage: {
      type: Boolean,
      default: false,
    },
    pathSrc: {
      type: String,
      default: '',
    },
    file: {
      type: [String, Array],
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    // 上传的文件类型 image图片 file文件
    type: {
      type: String,
      default: 'image',
    },
    autoCropWidth: {
      type: [String, Number],
      default: '200',
    },
    autoCropHeight: {
      type: [String, Number],
      default: '200',
    },
    count: {
      type: Number,
      default: 1,
    },
    defaultList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  components: { caijian },
  created() {
    console.log('created')
    console.log('defaultList', this.defaultList)
    this.autoCropHeights = this.autoCropHeight + ''
    this.autoCropWidths = this.autoCropWidth + ''
    console.log('fileList111', this.fileList)
    console.log(this.uploadImgUrl, 'uploadImgUrl')
    console.log(this.file, 'filefilefilefile')
    this.fileList = []
    if (this.file) {
      // this.fileList=[]
      // if (this.count == 1) {
      //   this.imageUrl = this.file
      // } else {
      //   let arr = []
      //   this.file.forEach((v) => {
      //     console.log(this.$url + v, 'this.$url + v')
      //     arr.push({ uid: v, url: this.$url + v })
      //   })
      //   this.fileList = arr
      //   console.log(this.fileList, '测试轮播信息展示===')
      // }
    }
  },
  mounted() {
    console.log('mounted')
  },
  data() {
    return {
      loading: false,
      open: false,
      visibleCai: false,
      errorImage: require('/src/assets/images/defaultImg.png'),
      autoCropWidths: null,
      autoCropHeights: null,
      fileName: '',
      imageUrl: '',
      form: {
        sceneName: '',
      },
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/common/local/file/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
      },
      previewVisible: false,
      previewImage: '',
      // fileList: [

      // ],
      rules: {
        sceneName: [{ required: true, message: '请输入场景名称', trigger: 'blur' }],
      },
      uuid: '',
    }
  },
  methods: {
    beforeUpload(file) {
      // 文件类型(file.type)、大小限制(file.size)
      if (this.isUpload) {
        // const reader = new FileReader()
        // 把Array Buffer转化为blob 如果是base64不需要
        // 转化为base64
        // reader.readAsDataURL(file)
        // reader.onload = () => {
        //   this.options.img = reader.result
        // }
        // this.fileName = file.name
        // // 转化为blob
        // // reader.readAsArrayBuffer(file)
        // return false
        this.$nextTick(() => {
          this.$refs.caijian.beforeUpload(file)
        })
        return false
      } else {
        return new Promise((resolve, reject) => {
          // 视频类型直接放行（无需像素判断）
          if (this.type === 'video') {
            resolve(true)
            return
          }

          const img = new Image()
          img.onload = () => {
            const width = img.width
            const height = img.height
            const minWidth = Number(this.autoCropWidth)
            const minHeight = Number(this.autoCropHeight)
            console.log(img, 'imgimgimgimg')
            console.log(minHeight, 'minHeightminHeight')
            if (minWidth && minHeight && this.isSize) {
              if ((minWidth && width !== minWidth) || height !== minHeight) {
                // 提示错误，reject 中断上传（不会进入 customRequest）
                this.$message.error(`图片像素尺寸过小，请上传 ${minWidth}*${minHeight} 及以上的图片`)
                reject(false) // 中断流程
              } else {
                // 像素合格，放行上传（进入 customRequest）
                resolve(true)
              }
              URL.revokeObjectURL(img.src)
            } else {
              console.log(width, 'widthwidthwidth')
              console.log(height, 'heightheightheight')
              if (width / height == 2 && width > 1000) {
                const originalFileName = file.name
                const fileNameWithoutExt = originalFileName.substring(0, originalFileName.lastIndexOf('.'))
                const fileExt = originalFileName.substring(originalFileName.lastIndexOf('.') + 1)
                console.log('文件名（不含后缀）：', fileNameWithoutExt) // 如 "风景图"
                this.$emit('backName', fileNameWithoutExt)
                resolve(true)
              } else {
                if (minHeight) {
                  resolve(true)
                } else {
                  this.$message.error('请上传正确的全景图片')
                  reject(false)
                }
              }
            }
          }
          img.onerror = () => {
            this.$message.error('无法读取图片信息，请重新选择')
            reject(false)
          }
          img.src = URL.createObjectURL(file)
        })
      }
    },
    // 点击提交
    submitForm() {
      console.log(this.form, 'sceneNamesceneNamesceneName');
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          let arr = []
          this.fileList.forEach(v => {
            if (this.uuid == v.uid) {
              v.name = this.form.sceneName
              this.previewVisible = false
            }
            arr.push({ originalImageUrl: v.originalImageUrl, sceneName: v.name, extendS1: v.originalImageUrl })
          })
          setTimeout(() => {
            this.$emit('input', arr)
          }, 0);
        }
      })
    },
    // 获取文件名称
    generateCosKey(name, ext) {
      var ymd = moment().format('YYYYMMDD')
      var ymd = moment().format('YYYYMMDD_HHmmss_')
      var r = ('000000' + Math.random() * 1000000).slice(-6)
      var cosKey = name + `/IMG_${ymd}_${r}.${ext}`
      return cosKey
    },
    camSafeUrlEncode(str) {
      return encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
    },
    init(w, h) {
      this.autoCropWidths = w
      this.autoCropHeights = h
    },
    customRequest(options) {
      console.log(options, 'optionsoptions');

      let that = this
      that.loading = true
      const { file, onProgress, onSuccess, onError } = options
      console.log(file, onProgress, onSuccess, onError, 'file, onProgress, onSuccess, onError')
      console.log(file, '对对对对对对')
      var lastIndex = file.name.lastIndexOf('.')
      console.log('选择的图片路径fileName', lastIndex)
      var extName = lastIndex > -1 ? file.name.slice(lastIndex + 1) : ''
      console.log(extName, 'extNameextNameextName')
      console.log(this.$cosUrl, 'this.$cosUrl')
      const name = file.name.substring(0, lastIndex)
      console.log(name, 'namenamenamename')
      const path = this.pathSrc ? this.pathSrc : this.$cosUrl
      console.log(path, 'pathpathpath.$cosUrl')
      console.log(this.pathSrc, 'this.pathSrc.$cosUrl')
      const cosKey = this.generateCosKey(path, extName)
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        const tempPreviewUrl = e.target.result; // base64 临时预览图
        console.log(tempPreviewUrl, 'tempPreviewUrltempPreviewUrl');
        // // 初始化 file 项
        const fileItem = {
          uid: file.uid,
          name: name,
          status: 'uploading',
          percent: 0,
          url: tempPreviewUrl,
          thumbUrl: tempPreviewUrl,
        }
        // 添加到 fileList
        this.fileList = [...this.fileList, fileItem]
        const fileNames = cosKey.split('/').pop()
        console.log(fileNames, 'fileNamesfileNamesfileNames')
        console.log(cosKey, 'cosKeycosKeycosKey')
        let indexNum = this.fileList.findIndex(f => f.uid === file.uid)
        ossSignature().then((res) => {
          res = res.data
          const cos = new COS({
            SecretId: res.tmpSecretId,
            SecretKey: res.tmpSecretKey,
            SecurityToken: res.sessionToken, // sts服务下发的临时 SessionToken
            StartTime: res.startTime, // 建议传入服务端时间，可避免客户端时间不准导致的签名错误
            ExpiredTime: res.expiredTime, // 临时密钥过期时间
          })
          const obj = {
            Bucket: this.$Bucket, // 对象存储桶名称
            Region: 'ap-guangzhou', // 地域
            Key: cosKey, // 文件路径
            Body: file, // 文件对象
            SliceSize: 1024 * 1024 * 5,
            // 修复：精准传递进度到当前文件
            onProgress: progressData => {
              const percent = Math.floor((progressData.loaded / progressData.total) * 100)
              console.log(percent, 'percentpercent');
              console.log(this.fileList, 'fileListfileList');
              // 更新进度
              console.log(indexNum, 'indexNum');
              if (indexNum !== -1) {
                this.fileList[indexNum].percent = percent
                this.fileList[indexNum].status = 'uploading'
                this.$forceUpdate() // 强制刷新
              }
              // 关键：第一个参数必须是 { percent }，第二个是当前 file
              onProgress({ percent }, file)
            }
          }
          if (this.type !== 'video') {
            obj.Headers = {
              'Pic-Operations': JSON.stringify({
                is_pic_info: 1, // 返回图片信息
                rules: [
                  {
                    fileid: cosKey, // 压缩后的文件名
                    rule: 'imageMogr2/quality/33', // 启用极智压缩
                  },
                ],
              }),
            }
          }
          cos.putObject(obj, function (err, data) {
            if (err) {
              console.log('上传失败', err)
              that.loading = false
              onError(err) // 补充失败回调
            } else {
              console.log('上传成功55555')
              that.loading = false
              // 构造上传后的真实 URL
              const finalUrl = that.$url + cosKey
              console.log(finalUrl, 'finalUrlfinalUrl');
              // 关键：设置 file 的 url 和 thumbUrl，防止 base64 预览
              // file.url = finalUrl
              // file.thumbUrl = finalUrl
              that.fileList[indexNum].url = finalUrl
              that.fileList[indexNum].thumbUrl = finalUrl
              that.fileList[indexNum].originalImageUrl = cosKey
              that.$forceUpdate()
              // 补充成功回调，告知组件上传完成
              onSuccess({ url: finalUrl }, file)
              that.handleOk(cosKey, name)
            }
          })
        })
      }
      console.log(this.fileList, 'this.fileList this.fileList ');
    },
    handleOk(e, name) {
      if (this.count === 1) {
        this.imageUrl = e
        console.log(this.imageUrl, ' this.imageUrl this.imageUrl')
        this.$emit('input', e)
      } else {
        const finalUrl = this.$url + e
        console.log(e, 'dddddd点点滴');
        // if(this.fileList)
        // this.fileList.push({ originalImageUrl: e, name: name, extendS1: e })
        // this.fileList.push({
        //   uid: e,
        //   name: name,
        //   url: finalUrl,
        //   thumbUrl: finalUrl,
        // })
        let arr = []
        this.fileList.forEach(v => {
          arr.push({ originalImageUrl: v.originalImageUrl, sceneName: v.name, extendS1: v.originalImageUrl })
        })
        setTimeout(() => {
          this.$emit('input', arr)
        }, 0);
      }
    },
    async handleChange(info) {
      console.log(info, 'infoinfoinfoinfo5555s')
      console.log('info上传图片得到的数据', info)
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        console.log('是否进入疑问词')
        if (info.file.response.code !== '20001') {
          this.$message.error('上传失败' + info.file.response.msg)
          this.loading = false
          return
        }
        this.loading = false
        console.log(info, 'infoinfoinfoinfo5555s')
        this.visibleCai = true
        this.imageUrl = info.file.response.data
        console.log(this.uploadImgUrls + this.imageUrl, '的点点滴滴')

        this.$emit('input', info.file.response.url)
      }
      // this.loading = true
      // new UploadFileToOSS([info.file], {
      //   finally: (res) => {
      //     console.log('上传成功回调', res)
      //     this.loading = false
      //     this.fileList = this.fileList.concat(res)
      //     console.log('fileList', this.fileList)
      //   },
      // })
    },
    changeImg(info) {
      console.log('info', info)
      // {
      //   "file": {
      //       "uid": "48718960",
      //       "name": "aaa002fd-22dc-4e42-9f56-8335ed3e8e92.png",
      //       "status": "removed",
      //       "path": "https://static.xiaoxinxin.com/2023-08-10/aaa002fd-22dc-4e42-9f56-8335ed3e8e92.png",
      //       "url": "https://static.xiaoxinxin.com/2023-08-10/aaa002fd-22dc-4e42-9f56-8335ed3e8e92.png",
      //       "cover": ""
      //   },
      //   "fileList": []
      // }
      if (info.file.status === 'removed') {
        console.log(1111)

        if (this.count === 1) {
          this.fileList = []
        } else {
          let index = this.fileList.findIndex((ele) => ele.uid === info.file.uid)
          this.fileList.splice(index, 1)
          let arr = this.fileList.map((v) => v.uid)
          this.$emit('input', arr)
        }
        this.$forceUpdate()
      }
    },
    removeFirstTargetStr(str, target) {
      const index = str.indexOf(target); // 找到第一个匹配的起始位置
      if (index === -1) return str; // 没找到则返回原字符串
      // 拼接：目标前的部分 + 目标后的部分
      return str.slice(0, index) + str.slice(index + target.length);
    },
    /**图片预览 */
    async handlePreview(file) {
      console.log(file, 'filefile,')
      this.previewImage = file.url
      this.form.sceneName = file.name
      this.previewVisible = true
      if (this.$refs.form) {
        this.$refs.form.clearValidate('sceneName');
      }
      this.uuid = file.uid
      console.log(this.uuid, 'this.uuid this.uuid ')
    },
    handleCancel() {
      this.previewVisible = false
    },
  },
}
</script>
<style lang="less" scoped>
img {
  width: 128px;
  height: 128px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.uplaod_r {
  position: relative;

  .uplaod_f {
    position: absolute;
    left: 0;
    bottom: -15px;
  }
}

video {
  width: 100px;
  height: 100px;
}

/* tile uploaded pictures */
.ant-upload-list-item {
  float: left;
  width: 200px;
  margin-right: 8px;
}

.ant-upload-animate-enter {
  animation-name: uploadAnimateInlineIn;
}

.ant-upload-animate-leave {
  animation-name: uploadAnimateInlineOut;
}

.upload-list-inline {
  background: red;
  width: 50% !important;
}

:deep(.ant-upload-list-picture) {
  display: flex !important;
  align-items: center !important;
  flex-wrap: wrap !important;
}

:deep(.ant-upload-list-picture div[class='']) {
  width: 49% !important;
  margin-right: 10px !important;

  &:nth-child(2n) {
    margin-right: 0 !important;
  }
}

.imageVis {
  width: 100%;
  height: 300px;
}
</style>
